module.exports = __webpack_public_path__ + "images/newerp_button2.1788921444950.png";